import { getCookie } from './cookie-handler';

export function getSessionKey() {
    return getCookie('TNEWSESSID') || null;
}

export function getPromo() {
    return getCookie('basker_tnew_promo');
}

export function getLoggedIn() {
    return getCookie('basker_tnew_logged_in');
}

export function getCartCount() {
    return getCookie('basker_tnew_cart_count');
}

export function getSourceId() {
    return getCookie('basker_tnew_source_id');
}

export function getOrderId() {
    return getCookie('basker_tnew_order_id');
}
